import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

import { MarvDateService } from '@marv/services';

@Pipe({
    name: 'marvMinutesToString'
})
export class MarvMinutesToString implements PipeTransform {

    constructor(){}

    transform(value: unknown): string {
        let time = ''; 
        if(value && typeof value === 'number'){
            time = MarvDateService.MinutesToStr(value, 'H');
        }
        return time;
    }

}
